/**
 * Padron Flooring - Shopify Forms conditional field
 * Form: forms-root-999553 (Trade Program)
 *
 * Show "Consultant Name" only when referred Yes/No is Yes.
 *
 * The floating label (id=label-custom#consultant_name) sits outside the
 * field wrapper. Hide the shared field group (label + wrap) so neither
 * leave a gap. On show, re-center the label top (see
 * fixConsultantLabelTop) since Forms measured it while hidden.
 */
(function () {
  var TRIGGER_INPUT_NAME =
    'custom#were_you_referred_by_a_padron_flooring_team_member';
  var CONSULTANT_LABEL_ID = 'label-custom#consultant_name';
  var YES_RE = /^\s*yes\s*$/i;
  var DEBUG =
    /(?:\?|&)padron_debug=1(?:&|$)/.test(window.location.search) ||
    window.PADRON_TRADE_FORM_DEBUG === true;

  var mutating = false;

  function log() {
    if (!DEBUG) return;
    var args = ['[padron-trade-form-conditional]'].concat(
      Array.prototype.slice.call(arguments)
    );
    console.log.apply(console, args);
  }

  function className(el) {
    if (!el || !el.className) return '';
    return typeof el.className === 'string'
      ? el.className
      : String(el.className.baseVal || '');
  }

  function fieldWrap(node) {
    var el = node;
    while (el && el.nodeType === 1) {
      if (/formFieldContainer/i.test(className(el))) return el;
      el = el.parentElement;
    }
    return node ? node.parentElement : null;
  }

  function nearestCommonAncestor(a, b, root) {
    if (!a || !b) return null;
    var seen = [];
    var el = a;
    while (el && el !== root) {
      seen.push(el);
      el = el.parentElement;
    }
    el = b;
    while (el && el !== root) {
      if (seen.indexOf(el) !== -1) return el;
      el = el.parentElement;
    }
    return null;
  }

  function isTooBroadGroup(el) {
    if (!el) return true;
    var cls = className(el);
    // Avoid hiding the whole form body / step container.
    return /formBody|formContent|formContainer|formWrapper|formRoot|formsEmbed/i.test(
      cls
    );
  }

  /**
   * Prefer one parent that owns both floating label + field wrap.
   * Falls back to null when the only common ancestor also holds the trigger
   * (or the whole form) -- caller then hides wrap + label separately.
   */
  function findFieldGroup(label, wrap, triggerWrap, root) {
    if (!wrap) return null;

    var group = null;
    if (label && label.parentElement && label.parentElement.contains(wrap)) {
      group = label.parentElement;
    } else if (
      wrap.parentElement &&
      (!label || wrap.parentElement.contains(label))
    ) {
      group = wrap.parentElement;
    } else {
      group = nearestCommonAncestor(label, wrap, root);
    }

    if (!group || group === root || isTooBroadGroup(group)) return null;
    if (triggerWrap && group.contains(triggerWrap)) return null;
    return group;
  }

  function withMute(fn) {
    mutating = true;
    try {
      fn();
    } finally {
      setTimeout(function () {
        mutating = false;
      }, 0);
    }
  }

  function findTrigger(root) {
    var control =
      root.querySelector(
        'input[name="' +
          TRIGGER_INPUT_NAME +
          '"], select[name="' +
          TRIGGER_INPUT_NAME +
          '"]'
      ) ||
      root.querySelector(
        'input[name*="were_you_referred_by_a_padron_flooring_team_member"], select[name*="were_you_referred_by_a_padron_flooring_team_member"]'
      );
    if (!control) return null;

    var wrap =
      control.closest('fieldset') ||
      fieldWrap(control) ||
      control.parentElement;
    return { wrap: wrap, control: control };
  }

  function findConsultantLabel(root) {
    return (
      root.getElementById(CONSULTANT_LABEL_ID) ||
      root.querySelector('[id="label-custom#consultant_name"]')
    );
  }

  function findTarget(root, triggerWrap) {
    var label = findConsultantLabel(root);
    var control = null;

    if (label) {
      control =
        label.control ||
        (label.htmlFor && root.getElementById(label.htmlFor)) ||
        (label.parentElement &&
          label.parentElement.querySelector('input, textarea')) ||
        null;
    }

    if (!control) {
      control =
        root.querySelector('input[name*="consultant_name" i]') ||
        root.querySelector('input[placeholder*="Consultant Name" i]') ||
        root.querySelector('input[name*="consultant" i]');
    }

    if (!control && !label) return null;

    var wrap = fieldWrap(control || label) || (control || label).parentElement;
    var group = findFieldGroup(label, wrap, triggerWrap || null, root);
    return { wrap: wrap, control: control, label: label, group: group };
  }

  function readChoice(control) {
    if (!control) return '';
    var root = control.getRootNode();
    var name = control.name || TRIGGER_INPUT_NAME;
    var radios = root.querySelectorAll(
      'input[type="radio"][name="' + name + '"]'
    );
    for (var i = 0; i < radios.length; i++) {
      if (!radios[i].checked) continue;
      var value = radios[i].value || '';
      var lab = '';
      if (radios[i].labels && radios[i].labels[0]) {
        lab = radios[i].labels[0].textContent || '';
      } else {
        var near = radios[i].closest('label') || radios[i].parentElement;
        lab = near ? near.textContent : '';
      }
      return (lab || value).replace(/\s+/g, ' ').trim();
    }
    if (control.tagName === 'SELECT') {
      var opt = control.options[control.selectedIndex];
      return ((opt && opt.textContent) || control.value || '').trim();
    }
    return '';
  }

  function isYes(control) {
    var choice = readChoice(control);
    log('choice', choice);
    return YES_RE.test(choice) || /^yes\b/i.test(choice);
  }

  function setHiddenEl(el, hidden) {
    if (!el) return;
    if (hidden) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    } else {
      el.style.removeProperty('display');
      el.removeAttribute('hidden');
      el.removeAttribute('aria-hidden');
    }
  }

  /**
   * Forms sets label top = inputHeight / 2 - labelHeight / 2, but measures
   * labelHeight once on mount. The field is hidden then, so it reads 0 and
   * the label lands too low (e.g. 23px instead of 16px). Reapply the same
   * formula with the real label height once the field is visible.
   */
  function fixConsultantLabelTop(label, control) {
    if (!label || !control || !label.style) return;
    var inputH = control.clientHeight;
    var labelH = label.offsetHeight;
    if (!inputH || !labelH) return;
    var top = Math.round(inputH / 2 - labelH / 2) + 'px';
    if (label.style.top !== top) label.style.top = top;
  }

  function watchConsultantLabelTop(label, control) {
    if (!label || label.__padronTopWatch) return;
    label.__padronTopWatch = true;
    var obs = new MutationObserver(function () {
      fixConsultantLabelTop(label, control);
    });
    obs.observe(label, {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  function setHidden(target, hidden) {
    if (!target) return;
    withMute(function () {
      if (target.group) {
        // One node owns label + input; avoids leftover / oversized gaps.
        setHiddenEl(target.group, hidden);
        if (!hidden) {
          setHiddenEl(target.wrap, false);
          setHiddenEl(target.label, false);
        }
      } else {
        setHiddenEl(target.wrap, hidden);
        setHiddenEl(target.label, hidden);
      }
      if (hidden && target.control) {
        target.control.value = '';
      }
    });
    if (!hidden && target.label) {
      watchConsultantLabelTop(target.label, target.control);
      fixConsultantLabelTop(target.label, target.control);
    }
  }

  function wire(root) {
    if (!root || root.__padronTradeConditional) {
      return !!root.__padronTradeConditional;
    }

    var trigger = findTrigger(root);
    var target = findTarget(root, trigger && trigger.wrap);
    if (!trigger || !target || !target.wrap || target.wrap === trigger.wrap) {
      return false;
    }

    root.__padronTradeConditional = true;
    log('wired', target.group ? 'group' : 'wrap+label');

    function sync() {
      var liveTrigger = findTrigger(root) || trigger;
      var liveTarget =
        findTarget(root, liveTrigger && liveTrigger.wrap) || target;
      setHidden(liveTarget, !isYes(liveTrigger.control));
    }

    root.addEventListener(
      'change',
      function (e) {
        if (
          !e.target ||
          String(e.target.name || '').indexOf(
            'were_you_referred_by_a_padron_flooring_team_member'
          ) === -1
        ) {
          return;
        }
        sync();
      },
      true
    );

    sync();
    return true;
  }

  function tryWireAll() {
    if (mutating) return false;
    var found = false;
    var embeds = document.querySelectorAll('shopify-forms-embed');
    for (var i = 0; i < embeds.length; i++) {
      if (embeds[i].shadowRoot && wire(embeds[i].shadowRoot)) found = true;
    }
    return found;
  }

  function init() {
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (tryWireAll() || tries > 40) {
        clearInterval(timer);
      }
    }, 500);

    var obs = new MutationObserver(function () {
      if (mutating) return;
      tryWireAll();
    });
    obs.observe(document.body || document.documentElement, {
      childList: true,
      subtree: true
    });

    tryWireAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
